module.exports = __webpack_public_path__ + "static/logo-6a0e5a109265f1fc0b3bfe578f08af4f.svg";